import { IImageLayer } from 'pages/ConfigurePage/FormImages/hooks';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { adjustImageSourceToUseS3ImageTransformator } from 'utils/adjustImageSourceToUseS3ImageTransformator';
import { LargeFormImageLayerImage } from '../FormImagesSwiper.styled';

interface ILargeFormImageLayerProps {
  layerKey: string;
  layer: IImageLayer;
  setError: Dispatch<SetStateAction<boolean>>;
  isPreview?: boolean;
  imageWidth?: number;
  imageHeight?: number;
}

export const LargeFormImageLayer = ({
  layerKey,
  layer,
  setError,
  isPreview = false,
  imageWidth,
  imageHeight,
}: ILargeFormImageLayerProps) => {
  const [isUsingFallbackImage, setIsUsingFallbackImage] =
    useState<boolean>(false);

  useEffect(() => {
    if (isUsingFallbackImage) {
      setIsUsingFallbackImage(false);
    }
  }, [layer]);

  return (
    <LargeFormImageLayerImage
      key={layerKey}
      src={adjustImageSourceToUseS3ImageTransformator(
        isUsingFallbackImage && layer.fallback ? layer.fallback : layer.source,
        imageWidth || (imageHeight ? 0 : 700),
        imageHeight || 0
      )}
      alt={''}
      $isPreview={isPreview}
      zIndex={layer.offset}
      onError={() => {
        console.log('Image failed to load: ', layer.source);
        if (!isUsingFallbackImage && layer.fallback) {
          setIsUsingFallbackImage(true);
        } else {
          setError(true);
        }
      }}
    />
  );
};
